import { Component, OnInit } from '@angular/core';

export interface Location {
  value: string;
  viewValue: string;
}

export interface Helmet {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-delivery-type',
  templateUrl: './delivery-type.component.html',
  styleUrls: ['./delivery-type.component.scss']
})
export class DeliveryTypeComponent implements OnInit {
  public show: boolean = true;
  public buttonName: any = 'Are you ready for more exciting plans?';
  constructor() { }
  divs: Array<any> = ["Menu1", "Menu2"];
  visibleDivId: number = null;

  selectedValue: string;
  locations: Location[] = [
    { value: '4th Floor Salarpuria Towers -1 22, Hosur Road, Koramangala, Bangalore Karnataka', viewValue: 'Kormangla' },
    { value: 'indiranagar', viewValue: 'Indira Nagar' },
  ];
  selectedValue1: string;
  helmets: Helmet[] = [
    { value: 'yes', viewValue: 'Yes' },
    { value: 'no', viewValue: 'No' },
  ];
  ngOnInit() {
  }
  toggleShow() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.buttonName = "Are you ready for more exciting plans?";
    else
      this.buttonName = "Back";
  }


  toggleVisibility(divId) {
    if (this.visibleDivId === divId) {
      //visibleDivId = null;
    } else {
      this.visibleDivId = divId;
    }
    this.hideNonVisibleDivs();
  }
  hideNonVisibleDivs() {

    let i, divId, div;
    for (i = 0; i < this.divs.length; i++) {
      divId = this.divs[i];
      div = document.getElementById(divId);
      if (this.visibleDivId === divId) {
        div.style.display = "block";
      } else {
        div.style.display = "none";
      }
    }
  }

  //   openNav() {
  //     document.getElementById("mySidenav").style.width = "50%";
  // }

  //  closeNav() {
  //     document.getElementById("mySidenav").style.width = "0";
  // }

}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/delivery-type/delivery-type.component.ts